import { Component } from "@angular/core";
import { AsyncPipe, NgIf } from "@angular/common";
import { GlobalLoaderService } from "src/app/shared/services/global-loader.service";

@Component({
  selector: "app-loader",
  standalone: true,
  templateUrl: "./global-loader.component.html",
  imports: [
    AsyncPipe,
    NgIf,
  ],
  styleUrls: ["./global-loader.component.scss"],
})
export class GlobalLoaderComponent {
  constructor(public loader: GlobalLoaderService) { }
}
